import Mixpanel from 'utils/mixpanelService';
import { getEventPageName } from 'utils/trackingPageUtils';

const freshworksActions = {
  hideLauncher: () => {
    if (window.FreshworksWidget) {
      window.FreshworksWidget('hide', 'launcher');
    }
  },
  isLoaded: () => !!window.FreshworksWidget,
  show: () => {
    const page = getEventPageName();
    Mixpanel.track('Support - Clicked', { page });
    if (window.FreshworksWidget) {
      window.FreshworksWidget('open');
    }
  },
};

export default freshworksActions;
